import React from 'react';
import { Dialog, Grid } from '@mui/material';
import styles from '../../../../../../../custom/style.module.css';
import { CustomButton, CustomDatePicker, CustomDialogAction, CustomDialogContent, CustomDialogTitle, CustomInputLabel, CustomTextField, InputProps, NUMBERINPUT_PROPS, StyledCard } from '../../../../../../../custom/components';
import { CloseIconBtn } from 'custom/constants';
import importStyles from './servicecatalog.module.css';
import moment from 'moment';
import dayjs from 'dayjs';

const EffectiveDetailsModal = (props) => {
  let value = props.serviceFieldsValue.value || {};
  let index = props.serviceFieldsValue.index;

  return (
    <div>
      <Dialog
        aria-labelledby='effective-details-title'
        open={props.modal == 'effective_details'}
        onClose={props.onClose}
        maxWidth={'sm'}
        fullWidth
        scroll='paper'>
        <CustomDialogTitle id='effective-details-title' className={styles.modalTitle}>
          Effective Details
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <CustomDialogContent>
          <StyledCard>
            <Grid container spacing={2}>
              {value?.unit != 'cost_manual' && <Grid item xs={12} md={12}>
                <CustomInputLabel className={importStyles.labelWrap} htmlFor='effective date '>Effective Date</CustomInputLabel>
                <CustomDatePicker
                  slotProps={{
                    textField: {
                      ...InputProps,
                      placeholder: 'Effective Date',
                      fullWidth: true,
                    },
                  }}
                  format='DD MMM YYYY'
                  className={`${styles.minWidth125}`}
                  onChange={(v) => props.onChangeOperation(index,
                    {
                      target: {
                        type: 'date',
                        name: 'effective_date',
                        value: moment(v.$d).format('YYYY-MM-DD')
                      }
                    })}
                  // value={dayjs(moment(props.userFields.retraining_date).format('YYYY-MM-DD'))}
                  value={value && value.effective_date ? dayjs(value.effective_date) : null}
                />
              </Grid>}
              {value?.unit != 'cost_manual' && ['number', 'kg', 'kg_per_day']?.includes(value.unit) && (
                <Grid item xs={12} md={12}>
                  <CustomInputLabel className={importStyles.labelWrap} htmlFor='new_cost_per_unit' required>Effective Cost Per Unit</CustomInputLabel>
                  <CustomTextField
                    fullWidth
                    id='new_cost_per_unit'
                    placeholder='Effective Cost Per Unit'
                    type='number'
                    onChange={(e) => props.onChangeOperation(index, e)}
                    name='new_cost_per_unit'
                    value={value.new_cost_per_unit}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: importStyles.operationsIpRoot,
                        input: importStyles.operationsIp
                      },
                    }}
                    sx={NUMBERINPUT_PROPS}
                    error={props.serviceFieldsErrors?.value && props.serviceFieldsErrors.value[index]?.new_cost_per_unit}
                  />
                </Grid>
              )}
              {value?.unit != 'cost_manual' && value.unit == 'cost' && (
                <Grid item xs={12} md={12}>
                  <CustomInputLabel className={importStyles.labelWrap} htmlFor='new_cost' required>Effective Cost</CustomInputLabel>
                  <CustomTextField
                    fullWidth
                    id='new_cost'
                    placeholder='Effective Cost'
                    type='number'
                    onChange={(e) => props.onChangeOperation(index, e)}
                    name='new_cost'
                    value={value.new_cost}
                    className={importStyles.operationsTextfield}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: importStyles.operationsIpRoot,
                        input: importStyles.operationsIp
                      },
                    }}
                    sx={NUMBERINPUT_PROPS}
                    error={props.serviceFieldsErrors?.value && props.serviceFieldsErrors.value[index]?.new_cost}
                  />
                </Grid>
              )}
              {value?.unit != 'cost_manual' && value.unit == 'percent' && (
                <Grid item xs={12} md={12}>
                  <CustomInputLabel className={importStyles.labelWrap} htmlFor='new_percent' required>Effective Percent</CustomInputLabel>
                  <CustomTextField
                    fullWidth
                    id='new_percent'
                    placeholder='Effective Percent'
                    type='number'
                    onChange={(e) => props.onChangeOperation(index, e)}
                    name='new_percent'
                    value={value.new_percent}
                    className={importStyles.operationsTextfield}
                    InputProps={{
                      disableUnderline: true,
                      classes: {
                        root: importStyles.operationsIpRoot,
                        input: importStyles.operationsIp
                      },
                    }}
                    sx={NUMBERINPUT_PROPS}
                    error={props.serviceFieldsErrors?.value && props.serviceFieldsErrors.value[index]?.new_percent}
                  />
                </Grid>
              )}
            </Grid>
          </StyledCard>
        </CustomDialogContent>
        <CustomDialogAction className={`${styles.fSpaceBtw}`}>
          <CustomButton variant='contained' type='reset' onClick={props.onClose}> Close</CustomButton>
          <CustomButton variant='contained' type='submit' onClick={props.action == 'add' ? props.addService : props.editService}>Submit</CustomButton>
        </CustomDialogAction>
      </Dialog>
    </div>
  );
};
export default EffectiveDetailsModal;